import { Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import useColors from "../../../../../../api/hooks/useColors";
import {
  getTextFieldInputProps,
  StyledTextField,
  textFieldLabelProps,
} from "../../../../../../components/forms/styles/formFieldStyles";

const JiraDescription = ({ required = false }) => {
  const colors = useColors();
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();

  const descriptionLabel = useMemo(() => {
    const hasValue = values.description?.trim();
    const labelText = hasValue
      ? "Issue description"
      : "Select issue description";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [values.description]);

  return (
    <StyledTextField
      margin="dense"
      name="description"
      label={descriptionLabel}
      fullWidth
      required={required}
      multiline
      minRows={4}
      maxRows={8}
      value={values.description || ""}
      onChange={(event) => setFieldValue("description", event.target.value)}
      error={!!touched.description && !!errors.description}
      helperText={
        touched.description && typeof errors.description === "string"
          ? errors.description
          : ""
      }
      onBlur={handleBlur}
      InputProps={getTextFieldInputProps({
        sx: {
          padding: 1,
          "& textarea": {
            padding: "14px",
          },
        },
      })}
      InputLabelProps={textFieldLabelProps()}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: colors.textfield_outlined_enabled_auto_generated_bg,
        },
      }}
    />
  );
};
export default JiraDescription;
